import Phaser from 'phaser';
import { SCENE_KEYS } from '../config/constants';
import { loadContent } from '../services/ContentLoader';
import { getTutorialStatus, startTutorial } from '../services/GameState';
import { UiOverlay } from '../services/UiOverlay';
import { PuzzleScene } from './PuzzleScene';

/**
 * Загрузка ассетов и content.json (один раз, кэш).
 * После загрузки запускается Hub.
 */
export class Preload extends Phaser.Scene {
  private static readonly LOAD_DELAY_MS = 400;

  constructor() {
    super({ key: SCENE_KEYS.Preload });
  }

  preload(): void {
    // Bitmap font ui-font не загружаем: ui-font.png отсутствует в репозитории; при появлении файла раскомментировать:
    // this.load.bitmapFont('ui-font', '/assets/fonts/ui-font.png', '/assets/fonts/ui-font.xml');
    this.load.audio('sfx_pick', [
      '/assets/audio/puzzle/puzzle_pick.ogg',
      '/assets/audio/puzzle/puzzle_pick.m4a',
    ]);
    this.load.audio('sfx_snap', [
      '/assets/audio/puzzle/puzzle_snap.ogg',
      '/assets/audio/puzzle/puzzle_snap.m4a',
    ]);
    this.load.audio('sfx_wrong', [
      '/assets/audio/puzzle/puzzle_wrong.ogg',
      '/assets/audio/puzzle/puzzle_wrong.m4a',
    ]);
    this.load.audio('sfx_victory', [
      '/assets/audio/puzzle/puzzle_victory.ogg',
      '/assets/audio/puzzle/puzzle_victory.m4a',
    ]);

    this.load.audio('ui_click', ['/assets/audio/ui/ui_click.ogg', '/assets/audio/ui/ui_click.m4a']);
    this.load.audio('ui_confirm', [
      '/assets/audio/ui/ui_confirm.ogg',
      '/assets/audio/ui/ui_confirm.m4a',
    ]);
    this.load.audio('ui_open', ['/assets/audio/ui/ui_open.ogg', '/assets/audio/ui/ui_open.m4a']);
    this.load.audio('ui_close', ['/assets/audio/ui/ui_close.ogg', '/assets/audio/ui/ui_close.m4a']);
  }

  async create(): Promise<void> {
    UiOverlay.showLoading();
    const content = await loadContent();
    if (content.packs.length === 0 || content.dailyPool.length === 0) {
      console.warn('Preload: content has no packs or dailyPool', {
        packs: content.packs.length,
        dailyPool: content.dailyPool.length,
      });
    } else {
      console.log('Preload: content ready, packs > 0, dailyPool > 0');
    }

    this.time.delayedCall(Preload.LOAD_DELAY_MS, () => {
      this.launchNext();
    });
  }

  private launchNext(): void {
    const status = getTutorialStatus();
    if (status === 'none' || status === 'step2') {
      startTutorial();
      if (!this.scene.get(SCENE_KEYS.Puzzle)) {
        this.scene.add(SCENE_KEYS.Puzzle, PuzzleScene, false);
      }
      const initialStep = status === 'step2' ? 2 : 1;
      this.scene.start(SCENE_KEYS.Puzzle, { mode: 'tutorial', initialStep });
    } else {
      this.launchHub();
    }
  }

  private launchHub(): void {
    import('../scenes/Hub').then((module) => {
      if (!this.scene.get(SCENE_KEYS.Hub)) {
        this.scene.add(SCENE_KEYS.Hub, module.Hub, false);
      }
      this.scene.start(SCENE_KEYS.Hub);
    });
  }
}
